import { getAdminAxiosInstance } from "../../../../api/Admin";

export const redeemReward = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/spin-wheel/redeem-spin-reward`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};